import { render, staticRenderFns } from "./Edito.vue?vue&type=template&id=8a382e26&"
import script from "./Edito.vue?vue&type=script&lang=ts&"
export * from "./Edito.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports